export default "__VITE_ASSET__CE_dryvQ__"